import {Supplier} from '../../types';
import {produce} from 'immer';


export function updateSupplierField<T extends keyof Supplier>(supplier : Supplier, key : T, value : Supplier[T]) : Supplier {
    return produce(supplier, draft => {
        draft[key] = value;
    })
}
